import Link from "next/link"
import { useLayoutData } from "../../../../../../utils/contexts/LayoutContext"
import { isSubNameAvailable, topBarHasLeftData } from "../../../../PartnerPortalLayout"

interface HeaderProps {
  openMobilMenu: () => void
}

const Header = ({
  openMobilMenu
}: HeaderProps) => {
  const { partnerSiteFull } = useLayoutData()
  const headerURL = partnerSiteFull?.content?.templateProperties?.items?.find((item) => item.key === "headerURL")?.value
  const headerImage = headerURL && headerURL !== "" ? headerURL : undefined;

  return (
    <>
      <div className={'header-info-area'} style={{ backgroundImage: headerImage ? `url('${headerImage}')` : undefined}}>
        <div className={'container-fluid px-2 px-md-5'}>
          <div className={'row align-items-center'}>
            <div className={'col-lg-12'}>
              <div className={'header-info-wrapper align-items-center'}>
                <div className={'logo'}>
                  <Link href="/">
                    <a>
                      <h1 className="h4 fw-bold mb-0">{partnerSiteFull?.partnerSite?.name}</h1>
                      {isSubNameAvailable(partnerSiteFull) ? (<span className={'h6'}>{partnerSiteFull?.partnerSite?.subName}</span>) : null}
                    </a>
                  </Link>
                </div>
                {topBarHasLeftData(partnerSiteFull) ? (
                  <div className="header-contact-info">
                    {partnerSiteFull?.content?.topBar?.items?.map((item, i) => {
                      if (!item.rightSide) {
                        return (
                          <div key={i} className="header-info-single-item">
                            <div className="header-info-single-item__icon">
                              <i className={`fa ${item.ikon}`} />
                            </div>
                            <div className="header-info-single-item__content">
                              <h6 className="header-info-single-item__title pt-2">{item.title}</h6>
                            </div>
                          </div>
                        )
                      }
                    })}
                  </div>
                ) : null}
                <div className="mobile-navigation-icon" id="mobile-menu-trigger" onClick={() => openMobilMenu()}>
                  <i />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header